// extracted by mini-css-extract-plugin
export var canvas = "styles-module--canvas--8593d";
export var container = "styles-module--container--e4d36";
export var scaleIn = "styles-module--scale-in--a1b50";